import AddIcon from '@material-ui/icons/Add';
import DefaultIconButton from '../../../../../@common/components/forms/DefaultIconButton';
import useModal from '../../../store/hooks/useModal';

export default ({ text }: any) => {
  const { openModal } = useModal();
  return <DefaultIconButton onClick={openModal} startIcon={<AddIcon />} text={text} />;
};
